/**
 * Módulo F-22 AT 2025 - Régimen 14 D N°8 (Pro Pyme Transparente), año comercial 2024.
 * Las secciones y el cálculo son los comunes del régimen (../../14d8). TAXI parte en el
 * AT 2025, así que no hay arrastre: el CPT inicial y lo pagado en 2024 se ingresan a mano.
 */
import { loadersComunes } from '../../14d8/modulo';

export * from '../../14d8/modulo';
export { createInitialState, rowToState, OUTPUT_CODES } from './persistence';
export { CODIGOS_PAGADO, CODIGOS_DESTACADOS } from './codigosPagado';

export const dataLoaders = loadersComunes(2025);
